import "./Home.module.css";
import MainHeader from "@/reusable_sections/Header";
import TrustedCollisionRepair from "./sections/TrustedCollisionRepair";
import CoreMaintenanceServices from "./sections/CoreMaintenanceServices";
import ThePhoneFixerDifference from "./sections/ThePhoneFixerDifference";
import PrecisionInEveryDetail from "./sections/PrecisionInEveryDetail";
import HomeownerSuccessStories from "./sections/HomeownerSuccessStories";
import SecureYourInfrastructure from "./sections/SecureYourInfrastructure";
import DealershipHubFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <MainHeader />
      <TrustedCollisionRepair />
      <CoreMaintenanceServices />
      <ThePhoneFixerDifference />
      <PrecisionInEveryDetail />
      <HomeownerSuccessStories />
      <SecureYourInfrastructure />
      <DealershipHubFooter />
    </div>;
}